export class InscricaoAluno {
    public id: number;
    public aluno: number;
    public dataInclusao: Date;
    public respostaQuestionario: number;
    public situacao: number;
    public periodo: string;
    public pontuacao: number;
    public detalhesPontuacao: string;
    public quantidadeSS: number;
    public quantidadeMS: number;
    public quantidadeMM: number;
    public quantidadeCC: number;
    public quantidadeMI: number;
    public quantidadeSR: number;
    public justificativaIndeferimento: string;
    public usuarioAtribuido: number;

    //variáveis transient
    // variaveis transient
    public alunoNome: string;
    public alunoRa: string;
    public alunoNivel: number;


}
